<div class="context-menu" [style.left.px]="position.x" [style.top.px]="position.y">
  <p class="lead p-2 ps-3 m-0 text-center border-bottom">Product Options</p>

  <!-- Navigation -->
  <button (click)="openShelfMenu.emit('openShelfMenu')">Shelf Menu</button>

  <!-- Copy -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('copy', $event)">
      Copy <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'copy'">
      <button (click)="copyProduct.emit('copyProduct')" [disabled]="!canEdit">Copy Product</button>
      <button (click)="copyStack.emit('copyStack')" [disabled]="!canEdit">Copy Stack</button>
    </div>
  </div>

  <!-- Paste -->
  <div class="submenu-container" *ngIf="hasClipboardProduct || hasClipboardStack">
    <button class="submenu-trigger" (click)="toggleSubmenu('paste', $event)">
      Paste <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'paste'">
        <button [disabled]="!canEdit" (click)="pasteProductAfter.emit('pasteProductAfter')" *ngIf="hasClipboardProduct">
          Paste After
        </button>
        <button [disabled]="!canEdit" (click)="pasteProductBefore.emit('pasteProductBefore')" *ngIf="hasClipboardProduct">
          Paste Before
        </button>
        <button [disabled]="!canEdit" (click)="pasteStackAfter.emit('pasteStackAfter')" *ngIf="hasClipboardStack">
          Paste After
        </button>
        <button [disabled]="!canEdit" (click)="pasteStackBefore.emit('pasteStackBefore')" *ngIf="hasClipboardStack">
          Paste Before
        </button>
    </div>
  </div>

  <!-- Modify -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('modify', $event)">
      Modify <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'modify'">
      <div class="section-header">Stack Height</div>
      <button [disabled]="!canEdit" (click)="modifyStackHeight.emit('increaseStackHeight')">Increase +1</button>
      <button [disabled]="!canEdit" (click)="modifyStackHeight.emit('decreaseStackHeight')">Decrease -1</button>
      <div class="section-header">Product Facings</div>
      <button [disabled]="!canEdit" (click)="modifyProductFacings.emit('increaseProductFacings')">Increase +1</button>
      <button [disabled]="!canEdit" (click)="modifyProductFacings.emit('decreaseProductFacings')">Decrease -1</button>
    </div>
  </div>

  <!-- Orientation -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('orientation', $event)">
      Orientation <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'orientation'">
      <div class="section-header">Orientation</div>
      <button (click)="changeOrientation.emit('changeOrientation:front')" [disabled]="!canEdit">Front</button>
      <button (click)="changeOrientation.emit('changeOrientation:front90')" [disabled]="!canEdit">Front 90°</button>
      <button (click)="changeOrientation.emit('changeOrientation:side')" [disabled]="!canEdit">Side</button>
      <button (click)="changeOrientation.emit('changeOrientation:side90')" [disabled]="!canEdit">Side 90°</button>
      <button (click)="changeOrientation.emit('changeOrientation:flatpack')" [disabled]="!canEdit">Flatpack</button>
      <button (click)="changeOrientation.emit('changeOrientation:flatpack90')" [disabled]="!canEdit">Flatpack 90°</button>
    </div>
  </div>

  <!-- Remove -->
  <div class="submenu-container">
    <button class="submenu-trigger" (click)="toggleSubmenu('remove', $event)">
      Remove <i class="bi bi-chevron-right chevron"></i>
    </button>
    <div class="submenu" [class.show]="expandedMenu === 'remove'">
      <button (click)="removeProduct.emit('removeProduct')" [disabled]="!canEdit">Remove Product</button>
      <button (click)="removeStack.emit('removeStack')" [disabled]="!canEdit">Remove Stack</button>
    </div>
  </div>
</div>